var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataEditor',{staticClass:"weekdays-editor",attrs:{"uimodel":_vm.weekdaysUiModel,"show-label":false,"ext-view-mode":"edit"},on:{"restore":function($event){return _vm.$emit('restore')},"input":_vm.updateWeekdays}})}
var staticRenderFns = []

export { render, staticRenderFns }